import React from "react"

type props = {
  children: JSX.Element | JSX.Element[]
}

const CustomTAndAWrapper: React.FC<props> = ({ children }) => {
  return (
    <div className="w-full h-full px-4 md:px-2 lg:px-2  py-2  wrapper ta-scope">
      {children}
    </div>
  )
}

export default CustomTAndAWrapper
